
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Container, Card, CardBody, CardTitle, CardText, Input, Label, Form, Button } from "reactstrap";
import { useSelector } from "react-redux";
import ReactPlayer from 'react-player';


const VideoSettingSingle = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { jobName, workflow, video } = location.state || {};
  const profileData = useSelector((state) => state.Profile.profileData);
  const videoUrl = video?.playback_url;

  const current_plan = profileData?.result?.current_plan;
  if (!jobName || !workflow || !video) {
    return <div>Error: Missing required data. Please go back and try again.</div>;
  }

  const [thumbnailSettings, setThumbnailSettings] = useState({
    width: '',
    height: '',
    maxCapture: '',
    enabled: true,
  });
  const [overlaySettings, setOverlaySettings] = useState({
    offsetTop: '',
    offsetLeft: '',
    width: '',
    height: '',
    startTime: '',
    enabled: true,
  });

  const [captionsSettings, setCaptionsSettings] = useState({
    enableCaptions: true,
    enableTranslation: true,
    captionFormat: "webvtt",
    languages: [],
  });

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    setCaptionsSettings((prev) => ({
      ...prev,
      [id]: checked,
    }));
  };

  const handleRadioChange = (e) => {
    const { value } = e.target;
    setCaptionsSettings((prev) => ({
      ...prev,
      captionFormat: value,
    }));
  };

  const [transcodeOption, setTranscodeOption] = useState("default");
  const [resolution, setResolution] = useState("");
  const [format, setFormat] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Transcode Option:", transcodeOption);
    // console.log("Resolution:", resolution);
    // console.log("Format:", format);
  };

  const handleCancel = () => {
    navigate("/video-processor");
  };


  const handleNext = () => {
    // const summary = {
    //   jobName,
    //   workflow,
    //   video,
    //   thumbnailSettings,
    //   overlaySettings,
    //   captionsSettings,
    //   hlsResolutions,
    //   dashResolutions,
    // }
    // console.log("Summary", summary);

    // navigate("/video-processor/video-setting-trans/summary", { state: summary });
  };

  document.title = "Media Pulse | Video Processor";

  return (
    <div className="page-content">
      <Container fluid>
        {/* Breadcrumb */}
        <BreadCrumb title="Video Setting" pageTitle="Video Processor" />

        {/* Cards Section */}
        <div className="row mt-4">
          {/* Job Details Card */}
          <div className="row align-items-stretch">
            <div className="col-md-6 d-flex flex-column">
              <Card className="mb-4">
                <CardBody>
                  <CardTitle tag="h5" style={{ color: "#6691e7" }}>Job Details</CardTitle>
                  <hr />
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <CardText>
                      <b>Job Name:</b> {jobName}
                    </CardText>
                    <CardText>
                      <b>Workflow Type:</b> {workflow}
                    </CardText>
                  </div>
                </CardBody>
              </Card>

              <Card className="mb-4">
                <CardBody>
                  <div>
                    <ReactPlayer
                      url={videoUrl}
                      controls
                      width="100%"
                      height="auto"
                    />
                  </div>
                </CardBody>
              </Card>
              {/* Transcode Video Card */}
              <Card className="mb-4">
                <CardBody>
                  <CardTitle tag="h5" style={{ color: "#6691e7" }}>Transcode Setting</CardTitle>
                  <hr />
                  <Form onSubmit={handleSubmit}>
                    {/* Select Transcode Settings */}
                    <div className="mb-3">
                      <label className="mb-2"><b>Select Transcode Settings</b></label>
                      <div className="d-flex">
                        <div className="form-check me-3">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="default"
                            name="transcodeOption"
                            value="default"
                            checked={transcodeOption === "default"}
                            onChange={() => setTranscodeOption("default")}
                          />
                          <label className="form-check-label" htmlFor="default">
                            Default
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            id="custom"
                            name="transcodeOption"
                            value="custom"
                            checked={transcodeOption === "custom"}
                            onChange={() => setTranscodeOption("custom")}
                          />
                          <label className="form-check-label" htmlFor="custom">
                            Custom
                          </label>
                        </div>
                      </div>
                    </div>

                    {/* Resolutions */}
                    <div className="mb-3 d-flex align-items-center">
                      <label className="me-2 mb-0"><b>Resolutions:</b></label>
                      {["360p", "480p", "1080p"].map((res) => (
                        <div className="form-check me-3" key={res}>
                          <input
                            className="form-check-input"
                            type="radio"
                            id={res}
                            name="resolution"
                            value={res}
                            checked={resolution === res}
                            onChange={(e) => setResolution(e.target.value)}
                          />
                          <label className="form-check-label" htmlFor={res}>
                            {res}
                          </label>
                        </div>
                      ))}
                    </div>

                    {/* Format */}
                    <div className="mb-3 d-flex align-items-center">
                      <label className="me-2"><b>Format:</b></label>

                      {transcodeOption === "default" ? (
                        // If "default" is selected, only show "LHS" without a radio button
                        <div className="form-check me-3">
                          <label className="form-check-label" htmlFor="HLS">
                            HLS
                          </label>
                        </div>
                      ) : (
                        // If "custom" is selected, show both "LHS" and "DASH" with radio buttons
                        ["HLS", "DASH"].map((fmt) => (
                          <div className="form-check me-3" key={fmt}>
                            <input
                              className="form-check-input"
                              type="radio"
                              id={fmt}
                              name="format"
                              value={fmt}
                              checked={format === fmt}
                              onChange={(e) => setFormat(e.target.value)}
                            />
                            <label className="form-check-label" htmlFor={fmt}>
                              {fmt}
                            </label>
                          </div>
                        ))
                      )}
                    </div>

                    {/* Submit Button */}
                    <div className="d-flex justify-content-end">
                      <Button type="submit"  style={{ background: "#eef9fd", color: "#50c3e6", border: "0", width: "100px"}}>
                        Submit
                      </Button>
                    </div>
                  </Form>
                </CardBody>

              </Card>
            </div>

            {/* Second Column */}
            <div className="col-md-6 d-flex flex-column">

              <Card className="mb-4">
                <CardBody>
                  <CardTitle tag="h5" style={{ color: "#6691e7" }}>Thumbnail Generation</CardTitle>
                  <hr />
                  {current_plan === "Basic" ? (
                    <>
                      <div className="form-check form-switch form-check-right mb-4">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="thumbnailSwitch"
                          defaultunChecked
                          disabled
                        />
                        <Label className="form-check-label text-muted " htmlFor="thumbnailSwitch">
                          Thumbnail Generation
                        </Label>
                      </div>
                      <div className="text-bold text-center">"Please update plan to unlock access to this feature."</div>
                    </>
                  ) : (
                    <>

                      <div className="row">
                        <div className="col-md-8">
                          <div className="row">
                            <div className="col-md-5 mb-3">
                              <label><b>No. of Thumbnails</b></label>
                              <input type="number" className="form-control" placeholder="Enter Number"
                                onChange={(e) => setThumbnailSettings({ ...thumbnailSettings, width: e.target.value })}
                              />
                            </div>
                            <div className="col-md-7 mb-3">
                              <label><b>Enter Time for Image Capture</b></label>
                              <input type="number" className="form-control" placeholder="Enter Time "
                                onChange={(e) => setThumbnailSettings({ ...thumbnailSettings, height: e.target.value })}
                              />
                            </div>
                          </div>
                        </div>

                      </div>
                    </>
                  )}
                  <div className="d-flex justify-content-end">
                      <Button type="submit"  style={{ background: "#eef9fd", color: "#50c3e6", border: "0", width: "100px"}}>
                        Submit
                      </Button>
                    </div>
                </CardBody>
              </Card>

              {/* Overlay Image Card */}
              <Card className="mb-4">
                <CardBody>
                  <CardTitle tag="h5" style={{ color: "#6691e7" }}>Overlay Image</CardTitle>
                  <hr />
                  {current_plan === "Basic" ? (
                    <>
                      <div className="form-check form-switch form-check-right mb-4">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="overlaySwitch"
                          defaultunChecked
                          disabled
                        />
                        <Label className="form-check-label text-muted " htmlFor="overlaySwitch">
                          Overlay Image
                        </Label>
                      </div>
                      <div className="text-bold text-center">"Please update plan to unlock access to this feature."</div>
                    </>
                  ) : (
                    <>
                      <div className="row">

                        <div className="col-md-6">
                          <button
                            type="button"
                            style={{ backgroundColor: "#eff4fd", height: "30px", width: "135px", marginBottom: "10px" }}
                            className="btn text-primary"
                          >
                            Upload Image
                          </button>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label><b>Offset From Top (pixels)</b></label>
                            <input type="number" className="form-control" placeholder="Enter Offset"
                              onChange={(e) => setOverlaySettings({ ...overlaySettings, offsetTop: e.target.value })} />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label><b>Offset From Left (pixels)</b></label>
                            <input type="number" className="form-control" placeholder="Enter Offset"
                              onChange={(e) => setOverlaySettings({ ...overlaySettings, offsetLeft: e.target.value })} />

                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label><b>Show Image after how many seconds</b></label>
                            <input type="number" className="form-control" placeholder="Enter Offset"
                              onChange={(e) => setOverlaySettings({ ...overlaySettings, offsetTop: e.target.value })} />
                          </div>
                        </div>

                      </div>
                    </>
                  )}
                  <div className="d-flex justify-content-end">
                      <Button type="submit"  style={{ background: "#eef9fd", color: "#50c3e6", border: "0", width: "100px"}}>
                        Submit
                      </Button>
                    </div>
                </CardBody>
              </Card>


              <Card className="mb-4">
                <CardBody>
                  <CardTitle tag="h5" style={{ color: "#6691e7" }}>Captions</CardTitle>
                  <hr />
                  {current_plan === "Basic" ? (
                    <>
                      <div className="form-check form-switch form-check-right mb-4">
                        <Input
                          className="form-check-input"
                          type="checkbox"
                          role="switch"
                          id="overlaySwitch"
                          defaultunChecked
                          disabled
                        />
                        <Label className="form-check-label text-muted " htmlFor="overlaySwitch">
                          Enable Captions
                        </Label>
                      </div>
                      <div className="text-bold text-center">"Please update plan to unlock access to this feature."</div>
                    </>
                  ) : (
                    <>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="mb-3">
                            <label><b>Select Caption Format</b></label>
                            <div className="d-flex align-items-center">
                              <div className="form-check me-3">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="captionFormat"
                                  id="webvttOption"
                                  value="WebVTT"
                                  checked={captionsSettings.captionFormat === "WebVTT"}
                                  onChange={handleRadioChange}
                                />
                                <label className="form-check-label" htmlFor="webvttOption">
                                  WebVTT
                                </label>
                              </div>
                              <div className="form-check me-3">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="captionFormat"
                                  id="srtOption"
                                  value="SRT"
                                  checked={captionsSettings.captionFormat === "SRT"}
                                  onChange={handleRadioChange}
                                />
                                <label className="form-check-label" htmlFor="srtOption">
                                  SRT
                                </label>
                              </div>
                              <div className="form-check">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="captionFormat"
                                  id="bothOption"
                                  value="WebVTT and  SRT"
                                  checked={captionsSettings.captionFormat === "WebVTT and  SRT"}
                                  onChange={handleRadioChange}
                                />
                                <label className="form-check-label" htmlFor="bothOption">
                                  Both
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-check form-switch form-check-right mb-4">
                            <Input
                              className="form-check-input"
                              type="checkbox"
                              role="switch"
                              id="enableTranslation"
                              checked={captionsSettings.enableTranslation}
                              onChange={handleCheckboxChange}
                            />
                            <Label className="form-check-label text-muted" htmlFor="overlaySwitch">
                              Enable Translation
                            </Label>

                          </div>
                        </div>
                      </div>
                      <div className="row">


                      </div>
                    </>
                  )}
                  <div className="d-flex justify-content-end">
                      <Button type="submit"  style={{ background: "#eef9fd", color: "#50c3e6", border: "0", width: "100px"}}>
                        Submit
                      </Button>
                    </div>
                </CardBody>
              </Card>
            </div>
          </div>
          <div className="d-flex justify-content-end mb-3 me-10">
            <button
              type="button"
              style={{ height: '40px', width: '100px', marginRight: "20px" }}
              className="btn btn-outline-primary"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="submit"
              style={{ height: '40px', width: '100px', marginRight: "20px"  }}
              className="btn btn-success"
              onClick={handleNext}
            >
              Next
            </button>
          </div>
        </div>
      </Container >
    </div >
  );
};

export default VideoSettingSingle;
